import React, {Component, Fragment} from 'react'
import FormGroup from './FormGroup'
import Label from './Label'
import Input from './Input'
import CaptchaImg from './CaptchaImg'


class RenderCaptchaInput extends Component {
    render() {
        return (
            <FormGroup {...this.props}>
                {
                    this.renderLabelInput()
                }
            </FormGroup>
        )
    }

    renderLabelInput = () => {
        let {label} = this.props

        return (
            <Fragment>
                <Label {...this.props}>
                    {
                        label
                    }
                </Label>
                <div className="row">
                    <div className="col-xs-4">
                        <CaptchaImg />
                    </div>
                    <div className="col-xs-8">
                        <Input {...this.props} />
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default RenderCaptchaInput


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Form/RenderCaptchaInput.js